import { Box, Icon, Typography } from '@mui/material'
import React, { useState } from 'react'
import image1 from '../assets/jobBoardInfoPic.webp'
import AdxFormModal from 'components/reusable/modal/AdxFormModal'

const JobBoardActivationInfoModal = () => {
  const [open, setOpen] = useState(false)
  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  return (
    <>
      <Typography
        sx={{ color: 'alternate.main', cursor: 'pointer', textDecoration: 'underline' }}
        onClick={handleOpen}
      >
        Learn more
      </Typography>
      <AdxFormModal
        open={open}
        handleClose={handleClose}
        icon={<Icon>info</Icon>}
        iconColor="information.main"
        title="About job board"
        modalWidth={500}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            gap: 2,
          }}
        >
          <Box
            sx={{
              height: '250px',
              width: '100%',
              background: 'linear-gradient(97deg, #D5FFFD 27.67%, #81D0D0 100.22%)',
              position: 'relative',
              flexShrink: 0,
            }}
          >
            <Box
              sx={{
                position: 'absolute',
                bottom: 12,
                left: '50%',
                transform: 'translateX(-50%)',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                width: '100%',
                height: '90%',
              }}
              component="img"
              alt=""
              src={image1}
            />
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              // justifyContent: 'space-between',
              alignItems: 'start',
              gap: '12px',
            }}
          >
            <Typography>
              Our Job Board is your gateway to sourcing top talent. This allows you to post your job
              openings, offering a seamless connection to a diverse pool of qualified candidates.
            </Typography>
            <Typography>
              With our easy-to-navigate interface, you can manage your listings, track applicants,
              and find the right match for your company's needs. Start by creating a job post today
              and tap into a network where opportunities meet potential.
            </Typography>
          </Box>
        </Box>
      </AdxFormModal>
    </>
  )
}

export default JobBoardActivationInfoModal
